<template>
    <div>
        <message-component id="message" v-model="isMessage" :success="this.message.success" style="white-space:pre-wrap; word-wrap:break-word;">{{ message.text }}</message-component>
        <div class="text-h4" style="margin-top: 15px;">
            契約確認の転送
        </div>
        <v-divider></v-divider>
        <validation-observer ref="observer" v-slot="{ invalid }" >
            <v-card class="mx-auto my-2" width="1000" min-width="1000">
                <v-card-text>
                    <v-container>
                        <v-overlay :value="sending" z-index="10000">
                            <v-progress-circular
                                indeterminate
                                size="64"
                            ></v-progress-circular>
                            <span class="loading">処理中です...</span>
                        </v-overlay>
                        <v-row justify="center">
                            <v-col class="py-0"><label-component horizontal="left">■この契約の関係者</label-component></v-col>
                        </v-row>
                        <v-row justify="center">
                            <v-col class="py-0">
                                <v-data-table :headers="headers" :items="stateItems" :items-per-page="itemsPerPage" hide-default-footer>
                                    <template v-slot:item.sn="{ index }">{{ index + 1 }}</template>
                                    <template v-slot:item.has_access_code="{ item }"><v-icon v-if="item.access_code">mdi-lock</v-icon></template>
                                    <template v-slot:item.edit="{ item }">
                                        <v-btn v-if="item.id == null" color="blue" class="white--text" @click="editItem(item)">編集</v-btn>
                                    </template>
                                    <template v-slot:item.delete="{ item }">
                                        <v-btn v-if="item.id == null" color="blue-grey" class="white--text" @click="confirmDialog(item)">削除</v-btn>
                                    </template>
                                    <template v-slot:item.remarks="{ index, item }">
                                        <div class="text-right" v-if="recipient.destination_email_address === item.destination_email_address"><span >(あなた)</span></div>
                                        <div class="text-right" v-else-if="item.signature_status == 3"><v-badge inline tile color="grey lighten-1" content="転送"></v-badge></div>
                                        <div class="text-right" v-else-if="item.id == null"><span>転送先</span></div>
                                    </template>
                                    <template v-slot:footer>
                                        <tr><td colspan=8 ><v-btn v-if="transfer == null" @click="addItem" class="ms-2 white--text" color="orange">転送先を追加</v-btn></td></tr>
                                    </template>
                                </v-data-table>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col class="py-0">
                                <badge-component tile content="任 意">
                                    <label-component horizontal="left">■転送先へのメッセージ</label-component>
                                </badge-component>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col class="py-0">
                                <validation-provider v-slot="{ errors }" name="transferMessage" rules="max:10000">
                                    <v-textarea auto-grow outlined clearable v-disabled-icon-focus rows="3" v-model="transferMessage"></v-textarea>
                                </validation-provider>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
            </v-card>
            <v-row justify="center">
                <v-col cols="auto">
                    <v-btn block class="ms-2 white--text" color="blue-grey" href="sign-input">キャンセル</v-btn>
                </v-col>
                <v-col cols="auto">
                    <v-btn :disabled="transfer == null" block class="ms-2 white--text" color="orange" v-on:click="next">転送する</v-btn>
                </v-col>
            </v-row>

            <!-- 転送先追加ダイアログ -->
            <v-dialog v-model="transferDialog" width="1000" class="common-dialog" persistent>
                <form @submit.prevent="pushOk">
                    <v-card color="#F4FEFB">
                        <v-card-title class="justify-center text-h5">
                            <p v-if="currentIndex !== null">転送先編集</p><p v-else>転送先追加</p>
                        </v-card-title>
                        <v-card-text class="common-dialog-message">
                            <v-container>
                                <v-row>
                                    <v-col cols="12" xl="3">
                                        <badge-component tile color="red" content="必　須">
                                            <label-component>氏名</label-component>
                                        </badge-component>
                                    </v-col>
                                    <v-col cols="12" xl="7">
                                        <validation-provider v-slot="{ errors }" name="destination_user_name" rules="required|max:100">
                                            <v-text-field outlined clearable v-disabled-icon-focus required :error-messages="errors" v-model="currentItem.destination_user_name" background-color="white"></v-text-field>
                                        </validation-provider>
                                    </v-col>
                                    <v-col cols="12" xl="3">
                                        <badge-component tile color="red" content="必　須">
                                            <label-component>メールアドレス</label-component>
                                        </badge-component>
                                    </v-col>
                                    <v-col cols="12" xl="7">
                                        <validation-provider v-slot="{ errors }" name="destination_email_address" rules="required|email|max:255" >
                                            <v-text-field required outlined clearable v-disabled-icon-focus required 
                                                :error-messages="errors" 
                                                v-model="currentItem.destination_email_address"
                                                background-color="white"
                                            >
                                            </v-text-field>
                                        </validation-provider>
                                    </v-col>
                                    <v-col cols="12" xl="3">
                                        <badge-component tile content="任　意">
                                            <label-component>会社名</label-component>
                                        </badge-component>
                                    </v-col>
                                    <v-col cols="12" xl="7">
                                        <validation-provider v-slot="{ errors }" name="destination_company_name" rules="max:50" >
                                            <v-text-field outlined clearable v-disabled-icon-focus :error-messages="errors" v-model="currentItem.destination_company_name" autocomplete="new-name" background-color="white"></v-text-field>
                                        </validation-provider>
                                    </v-col>
                                    <v-col cols="12" xl="3">
                                        <badge-component tile content="任　意">
                                            <label-component>アクセスコード</label-component>
                                        </badge-component>
                                    </v-col>
                                    <v-col cols="12" xl="7">
                                        <validation-provider v-slot="{ errors }" name="アクセスコード" rules="max:255|alpha_num_symbol:access_code_raw" >
                                            <!-- autocomplate対策ダミー -->
                                            <input type="email" name="hidden" id="hidden1" style="width: 0; height: 0; border: 0; padding: 0; top:-100px; position: fixed;" />
                                            <input type="password" name="hidden" id="hidden2" style="width: 0; height: 0; border: 0; padding: 0; top:-100px; position: fixed;" />
                                            <input style="visibility: hidden; top:-100px; position: fixed;" type="text" />
                                            <input style="visibility: hidden; top:-100px; position: fixed;" type="password" />
                                            <v-text-field outlined clearable v-disabled-icon-focus name="access_code" v-model="access_code" :error-messages="errors" ref="accessCodeInput"
                                                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                                                @click:append="show1 = !show1"
                                                autocomplete="new-password"
                                                oncopy="return false" onpaste="return false" oncontextmenu="return false"
                                                v-if="!reRendorFlag"
                                                background-color="white"
                                            ></v-text-field>
                                        </validation-provider>
                                        <validation-provider name="access_code_raw">
                                            <v-text-field 
                                                v-model="currentItem.access_code"
                                                readonly
                                                oncopy="return false" 
                                                onpaste="return false" 
                                                oncontextmenu="return false"
                                                style="visibility: hidden; top:-100px; position: fixed;"
                                            ></v-text-field>
                                        </validation-provider>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions class="justify-center grey lighten-4 pb-6">
                            <v-btn min-width="150px" class="white--text" color="blue-grey lighten-1" large @click="transferDialog = false;">キャンセル</v-btn>
                            <v-btn min-width="150px" class="white--text" color="red" large :disabled="invalid" @click="pushOk">OK</v-btn>
                        </v-card-actions>
                    </v-card>
                </form>
            </v-dialog>
        </validation-observer>
        <!-- 削除確認ダイアログ -->
        <simple-dialog-component v-if="confirmDeleteDialog" :dialog.sync="confirmDeleteDialog" :currentItem="currentItem" :currentIndex="currentIndex" @clickOk="deleteItem(currentItem)" okBtn="削除" cancelbtn="キャンセル">
            <div>{{ currentItem.destination_user_name }}を削除しますか？</div>
        </simple-dialog-component>
    </div>
</template>

<script>
    import { required, max, email } from 'vee-validate/dist/rules';
    import { extend, ValidationObserver, ValidationProvider } from 'vee-validate';
    
    extend('required', {...required, message: '入力必須項目です',});
    extend('email', {...email, message: '正しいメールアドレスを入力してください',});
    extend('max', {
        ...max,
        message: '{length} 文字以内でご入力ください',
    });
    
    export default {
        components:{
            ValidationProvider,  // 入力時にリアルタイムでエラーチェック
            ValidationObserver   // 送信時にエラーチェック
        },
        props: {
            recipient: Object,
            items: Array,
        },
        data() {
            return {
                errors: null,
                transfer: null,
                transferMessage: "",
                stateItems: [],
                currentIndex: Number,
                currentItem: {
                    destination_user_name: '',
                    destination_email_address: '',
                    destination_company_name: '',
                    access_code: '',
                },
                sending: false,
                transferDialog: false,
                show1: false,
                localAccessCode: '',
                reRendorFlag: false,
                confirmDeleteDialog: false,
                headers: [
                    { text: '', value: 'sn', sortable: false },
                    { text: '氏名', value: 'destination_user_name', sortable: false },
                    { text: 'メールアドレス', value: 'destination_email_address', sortable: false },
                    { text: '会社名', value: 'destination_company_name', sortable: false },
                    { text: '', value: 'has_access_code', sortable: false },
                    { text: '', value: 'edit', sortable: false },
                    { text: '', value: 'delete', sortable: false },
                    { text: '', value: 'remarks', sortable: false },
                ],
                itemsPerPage: -1,
                message: {
                    success: false,
                    text: '',
                }
            };
        },
        computed: {
            // <!-- autocomplate対策 暫定 -->
            access_code: {
                get() {
                    if (this.show1) {
                        return this.currentItem.access_code?? '';
                    } else {
                        let muskStr = '';
                        let str = this.currentItem.access_code?? '';
                        for (let i = 0; i < str.length; i++)
                        {
                            muskStr += '•';
                        }
                        return muskStr;
                    }
                },
                set(value) {
                    if (!this.show1) {
                        if (value != null && value.length > 0 ){
                            if (value.length >= this.localAccessCode.length) {
                                let newStr = value.replace(/•/g, '');
                                let newStrIndex = value.indexOf(newStr);
                                if (value.length == this.localAccessCode.length) {
                                    this.currentItem.access_code = this.currentItem.access_code.slice(0, newStrIndex) + newStr + this.currentItem.access_code.slice(newStrIndex + 1);
                                } else {
                                    this.currentItem.access_code = this.currentItem.access_code.slice(0, newStrIndex) + newStr + this.currentItem.access_code.slice(newStrIndex);
                                }
                            } else {
                                let removeStrLength = value.length - this.localAccessCode.length;
                                this.currentItem.access_code = this.currentItem.access_code.slice(0, removeStrLength);
                            }
                            this.localAccessCode = '';
                            for (let i = 0; i < value.length; i++)
                            {
                                this.localAccessCode += '•';
                            }
                            
                            // 再描画 TODO : スマートな方法
                            const ele = this.$refs.accessCodeInput;
                            ele.text = this.localAccessCode;
                            this.reRendorFlag = true;
                            // this.$nextTick(() => (this.reRendorFlag = false));
                            this.$nextTick(function() {
                                this.reRendorFlag = false;
                                setTimeout(() => {
                                    const ele = this.$refs.accessCodeInput;
                                    ele.$refs.input.focus();
                                    ele.$refs.input.setSelectionRange(ele.$refs.input.value.length, ele.$refs.input.value.length);
                                });
                            });
                        } else {
                            this.localAccessCode = '';
                            this.currentItem.access_code = '';
                        }
                        // this.item.access_code = value;
                    } else {
                        this.currentItem.access_code = value;
                        this.localAccessCode = '';
                        for (let i = 0; i < value.length; i++)
                        {
                            this.localAccessCode += '•';
                        }
                    }
                }
            },
            isMessage: {
                get() {
                    return this.message.text != '';
                },
                set(value) {
                    if (!value) {
                        this.message.text = '';
                    }
                }
            },
        },
        // 初期表示のデータ
        created : function() {
            this.stateItems = this.items;
        },
        methods: {
            next: async function() {
                this.sending = true;
                try {
                    let result = await this.save();
                    if (result) {
                        window.location = "transferred";
                    }
                }
                finally {
                    this.sending = false;
                }
            },
            // 保存
            save: async function() {
                let result = true;
                var self = this;
                await window.axios
                    .post('transfer', {
                        'transfer': this.transfer,
                        'transferMessage': this.transferMessage,
                    })
                    .then(function (response) {
                        if (response.data.success) {
                            result = true;
                        } 
                        else {
                            result = false;
                            if (response.data.message) {
                                self.message.text = response.data.message;
                            } else {
                                self.message.text = "保存処理に失敗しました";
                            }
                            self.message.success = false;
                        }
                    })
                    .catch(function (response) {
                        result = false;
                        console.log(response);
                        self.message.text = "保存処理に失敗しました";
                        self.message.success = false;
                    }
                );
                return result;
            },
            addItem: function() {
                this.currentIndex = null;
                this.currentItem = {
                    // id: '',
                    destination_user_name: '',
                    destination_email_address: '',
                    destination_company_name: '',
                    access_code: '',
                };
                this.transferDialog = true;
            },
            editItem: function(item) {
                this.currentIndex = this.stateItems.indexOf(item);
                // this.currentItem = item;
                this.currentItem = JSON.parse(JSON.stringify(item));    // クローンの意図
                this.transferDialog = true;
            },
            pushOk: function() {
                // バリデーション実行
                var self = this;
                this.$refs.observer.validate().then((result) => {
                    if(result) {
                        // TODO vee-validateで統一化したい
                        if (self.items.find(item => item.destination_email_address == self.currentItem.destination_email_address && item.id != null)) {
                            self.message.text = "すでに宛先に設定されているメールアドレスです";
                            self.message.success = false;
                            return false;
                        }
                        if (self.currentIndex == null) {
                            let addIndex = self.stateItems.findIndex((i)=>{ return self.recipient.id === i.id; }) + 1;
                            self.stateItems.splice(addIndex, 0, self.currentItem);
                        } else {
                            self.stateItems.splice(self.currentIndex, 1, self.currentItem);
                        }
                        self.transfer = self.currentItem;
                        self.transferDialog = false;
                    }
                });
            },
            confirmDialog: function(item) {
                this.currentIndex = this.stateItems.indexOf(item);
                this.currentItem = item;
                this.confirmDeleteDialog = true;
            },
            deleteItem: function(item) {
                const index = this.stateItems.indexOf(item);
                this.stateItems.splice(index, 1);
                this.transfer = null;
            },
        },
    };
</script>

<style scoped lang="scss">
    /* table */
    td {
        border-bottom: solid 1px rgb(0, 0, 0, 0.05);
        padding: 5px 0;
    }
    ::v-deep .v-data-table__empty-wrapper {
        display: none;
    }
</style>